import React, { useState, useEffect } from 'react';
import logoImg from './assets/LOGO.png';
import lotusImg from './assets/footer/lotus.png';

const Footer = () => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const [activePolicy, setActivePolicy] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Xử lý hiện/ẩn nút cuộn lên đầu trang
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // NỘI DUNG CHÍNH SÁCH ĐƯỢC GIỮ NGUYÊN 100%
  const policyContents = {
    "mua-hang": {
      title: "Chính sách mua hàng",
      content: (
        <div style={styles.modalBodyContent}>
          <h4 style={styles.subSectionTitle}>1. Điều khoản mua hàng</h4>
          <ul style={styles.modalList}>
            <li>Quý khách vui lòng chuyển khoản hoặc thanh toán cọc trước. <strong>Floraison</strong> sẽ lên đơn ngay sau khi nhận phí.</li>
            <li>Cửa hàng sẽ chụp ảnh xác nhận sản phẩm hoàn thiện trước khi giao (đối với khách hàng có yêu cầu).</li>
            <li>Do đặc thù sản phẩm là hoa tươi, chúng tôi hỗ trợ chỉnh sửa thiết kế theo yêu cầu tối đa <strong>3 lần</strong>.</li>
            <li>Cửa hàng tiếp nhận và giải quyết mọi phản hồi ngay trong ngày. Không xử lý đối với các sản phẩm khiếu nại qua ngày hôm sau.</li>
            <li>Trường hợp xảy ra thiếu sót (thiếu thiệp, sai nội dung thiệp, trễ giờ giao...), quý khách vui lòng gọi ngay hotline để nhận phản hồi và hỗ trợ xử lý sớm nhất.</li>
          </ul>
          
          <h4 style={styles.subSectionTitle}>2. Quy định về thời gian thông báo và gửi đổi trả</h4>
          <ul style={styles.modalList}>
            <li><strong>Thời gian thông báo:</strong> Trong vòng <strong>12 giờ</strong> kể từ khi nhận sản phẩm đối với trường hợp thiếu phụ kiện, quà tặng đi kèm hoặc sản phẩm bị bể vỡ.</li>
            <li><strong>Thời gian phản hồi:</strong> Chúng mình luôn cố gắng tiếp nhận và xử lý nhanh nhất có thể để hỗ trợ đơn hàng của bạn.</li>
            <li><strong>Kênh hỗ trợ nhanh nhất:</strong> Nhắn tin trực tiếp qua Fanpage hoặc gọi Hotline của cửa hàng.</li>
          </ul>
          <p style={{ marginTop: '12px', fontStyle: 'italic', fontSize: '14px', color: '#6e5a58' }}>
            * Nếu quý khách có bất kỳ ý kiến đóng góp hoặc khiếu nại nào liên quan đến chất lượng dịch vụ, vui lòng liên hệ đường dây chăm sóc khách hàng trực tiếp để chúng tôi hoàn thiện hơn.
          </p>
        </div>
      )
    },
    "van-chuyen": {
      title: "Chính sách vận chuyển",
      content: (
        <div style={styles.modalBodyContent}>
          <h4 style={styles.subSectionTitle}>1. Các phương thức giao hàng</h4>
          <ul style={styles.modalList}>
            <li>Khách hàng mua và nhận hoa trực tiếp tại cửa hàng của chúng tôi.</li>
            <li>Giao hàng tận nơi hỏa tốc thông qua các đơn vị vận chuyển chuyên nghiệp.</li>
          </ul>

          <h4 style={styles.subSectionTitle}>2. Thời hạn ước tính giao hàng</h4>
          <ul style={styles.modalList}>
            <li><strong>Floraison</strong> cam kết giao hoa sớm nhất sau <strong>2 tiếng</strong> kể từ khi khách hàng hoàn tất đặt hàng và thanh toán thành công.</li>
            <li>Khung giờ giao hoa linh hoạt từ <strong>7h30 đến 20h00</strong> hàng ngày. Những đơn hàng xác nhận sau 20h00 sẽ được ưu tiên xử lý và giao vào sáng ngày kế tiếp.</li>
            <li><em>Lưu ý bất khả kháng:</em> Trong các trường hợp thời tiết mưa bão nghiêm trọng hoặc không liên lạc được với người nhận, chúng tôi sẽ chủ động liên hệ lại người đặt để sắp xếp thời gian giao hàng thuận tiện nhất.</li>
          </ul>

          <h4 style={styles.subSectionTitle}>3. Giới hạn địa lý khi giao hàng</h4>
          <ul style={styles.modalList}>
            <li>Cung cấp dịch vụ đặt hoa tươi và giao hoa tận nơi trên toàn địa bàn <strong>TP. Hồ Chí Minh</strong>.</li>
            <li>Đối với các điểm giao đặc biệt (tòa nhà có bảo vệ nghiêm ngặt gây cản trở ship hàng, trung tâm hội nghị...), shipper sẽ liên hệ trước với người nhận để thống nhất vị trí giao nhận thuận lợi nhất.</li>
          </ul>

          <h4 style={styles.subSectionTitle}>4. Trách nhiệm khi hàng hóa bị hư hỏng do vận chuyển</h4>
          <ul style={styles.modalList}>
            <li>Dù đơn hàng do chính cửa hàng tự ship hay thông qua bên thứ ba, <strong>Floraison</strong> sẽ đứng ra chịu hoàn toàn trách nhiệm giải quyết vấn đề cho khách hàng.</li>
            <li>Khách hàng có quyền từ chối nhận hoa và yêu cầu đổi trả theo đúng quy định. Các vấn đề phát sinh sau đó sẽ do cửa hàng tự làm việc và xử lý đền bù với đối tác vận chuyển.</li>
            <li>Trường hợp xảy ra chậm trễ giờ giao, chúng tôi sẽ thông báo kịp thời. Khách hàng có quyền lựa chọn giữa việc <strong>Hủy đơn hoàn phí</strong> hoặc tiếp tục chờ nhận hàng.</li>
          </ul>
        </div>
      )
    },
    "doi-tra": {
      title: "Chính sách đổi trả và hoàn tiền",
      content: (
        <div style={styles.modalBodyContent}>
          <h4 style={styles.subSectionTitle}>1. Nguyên tắc giải quyết khiếu nại & Đổi trả</h4>
          <ul style={styles.modalList}>
            <li>Nếu chất lượng hoa tươi hoặc quà tặng khiến bạn không hài lòng, vui lòng chụp ảnh/video sản phẩm gửi ngay cho chúng tôi. <strong>Floraison</strong> sẽ giải quyết mọi phản ánh về chất lượng trong vòng 1 ngày.</li>
            <li>Đối với trường hợp đơn hàng không đến nơi, quý khách cần thông báo cho cửa hàng trong vòng 1 ngày kể từ ngày ấn định giao đơn hàng.</li>
            <li>Khoản thanh toán hoàn trả sẽ được chuyển về tài khoản ngân hàng, ví điện tử hoặc tài khoản ban đầu mà bạn đã dùng để đặt hàng. Quá trình hoàn tiền <strong>hoàn toàn không phát sinh chi phí</strong>.</li>
            <li><strong style={{ color: '#c0392b' }}>Điều kiện bắt buộc:</strong> Do quy trình kiểm soát chất lượng, cửa hàng không thể gửi sản phẩm mới thay thế hoặc hoàn tiền nếu quý khách không giữ lại sản phẩm lỗi hoặc không có hình ảnh/video chứng minh cụ thể.</li>
          </ul>

          <h4 style={styles.subSectionTitle}>2. Các danh mục hoàn tiền và đổi trả cụ thể</h4>
          <ul style={styles.modalList}>
            <li><strong>Hoàn trả đầy đủ (100%):</strong> Áp dụng đối với đơn hàng gặp lỗi nghiêm trọng từ phía nhà sản xuất hoặc khâu chuẩn bị.</li>
            <li><strong>Hoàn lại 50%:</strong> Tùy thuộc vào thỏa thuận và mức độ ảnh hưởng của sản phẩm.</li>
            <li><strong>Không hoàn trả:</strong> Đối với các trường hợp hư hỏng do phía khách hàng bảo quản sai cách sau khi nhận hàng qua thời gian quy định.</li>
          </ul>

          <h4 style={styles.subSectionTitle}>3. Quy định về việc thay thế hoa theo mùa</h4>
          <ul style={styles.modalList}>
            <li>Tùy thuộc vào tính chất mùa vụ, một số loại hoa đặc thù có thể không có sẵn tại thời điểm đặt. <strong>Floraison</strong> xin phép linh hoạt thay thế bằng các loài hoa khác có màu sắc và giá trị thẩm mỹ tương đương.</li>
            <li>Việc thay thế sẽ ưu tiên đảm bảo phong cách tổng thể, phom dáng và tone màu chủ đạo của thiết kế gốc để không làm giảm giá trị đơn hàng. Chúng tôi khuyến khích khách hàng cung cấp thêm một lựa chọn màu sắc dự phòng khi đặt hoa trực tuyến.</li>
            <li>Mọi khiếu nại hợp lệ về chất lượng hoa cần gửi kèm ảnh chụp trong vòng <strong>3 ngày</strong> để được hỗ trợ phương án khắc phục chu đáo nhất.</li>
          </ul>
        </div>
      )
    },
    "khieu-nai": {
      title: "Chính sách xử lý khiếu nại",
      content: (
        <div style={styles.modalBodyContent}>
          <ul style={styles.modalList}>
            <li><strong>Floraison</strong> sẵn sàng tiếp nhận mọi khiếu nại, đóng góp ý kiến của khách hàng liên quan trực tiếp đến việc trải nghiệm dịch vụ và sử dụng sản phẩm của công ty.</li>
            <li>Đối với tất cả các trường hợp cần xử lý bảo hành hoặc khắc phục lỗi sản phẩm, quý khách vui lòng liên hệ trực tiếp với tổng đài để nhân viên hướng dẫn làm thủ tục nhanh chóng.</li>
            <li><strong>Thời gian giải quyết:</strong> Thời gian phản hồi và đưa ra phương án xử lý dứt điểm khiếu nại tối đa là <strong>03 (ba) ngày làm việc</strong> kể từ khi nhận được thông tin.</li>
            <li>Trong các trường hợp phát sinh sự cố bất khả kháng (thiên tai, dịch bệnh, sự cố hệ thống toàn diện), hai bên sẽ cùng ưu tiên thương lượng trên tinh thần hợp tác, tôn trọng quyền lợi của nhau.</li>
          </ul>
        </div>
      )
    },
    "thanh-toan": {
      title: "Chính sách thanh toán",
      content: (
        <div style={styles.modalBodyContent}>
          <ul style={styles.modalList}>
            <li><strong>Floraison</strong> chấp nhận đa dạng phương thức thanh toán linh hoạt: Chuyển khoản ngân hàng trực tuyến, thanh toán qua ví điện tử (Momo, VNPay) hoặc nhận thanh toán tiền mặt trực tiếp khi giao hàng (COD) đối với một số danh mục sản phẩm tiêu chuẩn.</li>
          </ul>
        </div>
      )
    }
  };

  return (
    <footer style={styles.footerContainer} className="footer-container">
      {/* ẢNH HOA SEN DECOR - Đặt absolute góc phải */}
      <img src={lotusImg} alt="Lotus Decor" style={styles.lotusDecor} className="lotus-float footer-lotus" />

      <div style={styles.mainContent} className="footer-main-content">
        
        {/* CỘT 1: LOGO & COPYRIGHT */}
        <div style={styles.colLeft} className="footer-col-left">
          <img src={logoImg} alt="Floraison Logo" style={styles.logoImage} className="footer-logo" />
          <div style={styles.copyrightDivider} className="footer-divider"></div>
          <p style={styles.copyrightText} className="footer-copyright">©FLORAISON 2026. ALL RIGHT RESERVED.</p>
        </div>

        {/* CỘT 2: THÔNG TIN LIÊN HỆ */}
        <div style={styles.colCenter} className="footer-col-center">
          <h3 style={styles.headingStyle}>HOTLINE: 0338 788 804</h3>
          <h3 style={styles.headingStyle}>HỆ THỐNG CỬA HÀNG</h3>
          <ul style={styles.plainList}>
            <li style={styles.textItem}>Số 15 Đường D5, P. Thạnh Mỹ Tây, HCM</li>
            <li style={styles.textItem}>Thời gian: 8:00 A.M. - 17:00 P.M.</li>
            <li style={styles.textItem}>Email: floraison.hoa@gmail.com</li>
          </ul>
          
          {/* Social Icons tròn giống layout */}
          <div style={styles.socialGroup}>
            <a href="https://www.facebook.com/profile.php?id=61589648157549" target="_blank" rel="noreferrer" style={styles.socialIconBtn}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            </a>
            <a href="https://www.instagram.com/_floraison.fleur_/" target="_blank" rel="noreferrer" style={styles.socialIconBtn}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
          </div>
        </div>

        {/* CỘT 3: CHÍNH SÁCH / MENU */}
        <div style={styles.colRight} className="footer-col-right">
          {Object.keys(policyContents).map((key) => (
            <button 
              key={key}
              onClick={() => setActivePolicy(policyContents[key])}
              className="footer-menu-link"
              style={{
                ...styles.menuLink,
                color: hoveredLink === key ? '#8f86a8' : '#6e5a58',
              }}
              onMouseEnter={() => setHoveredLink(key)}
              onMouseLeave={() => setHoveredLink(null)}
            >
              {policyContents[key].title.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {/* FLOATING ACTION BUTTONS */}
      <div style={styles.floatingActionWrapper} className="footer-floating-actions">
        <button 
          onClick={scrollToTop} 
          style={{
            ...styles.floatingBtn,
            backgroundColor: '#FAF0F2',
            border: '1px solid #4a5c46',
            opacity: showScrollTop ? 1 : 0,
            visibility: showScrollTop ? 'visible' : 'hidden',
            pointerEvents: showScrollTop ? 'auto' : 'none'
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#4a5c46"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/></svg>
        </button>
        <a href="https://www.instagram.com/_floraison.fleur_/" target="_blank" rel="noreferrer" style={styles.floatingBtn}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61589648157549" style={styles.floatingBtn}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.923 1.503 5.518 3.829 7.218v3.94l3.504-1.921c.854.238 1.748.363 2.667.363 5.523 0 10-4.145 10-9.259S17.523 2 12 2zm1.094 12.392l-2.827-3.023-5.508 3.023 6.071-6.442 2.891 3.024 5.443-3.024-6.07 6.442z"/></svg>
        </a>
      </div>

      {/* MODAL CHÍNH SÁCH */}
      {activePolicy && (
        <div style={styles.overlayModal} onClick={() => setActivePolicy(null)}>
          <div style={styles.khungPopUp} className="footer-modal-khung" onClick={(e) => e.stopPropagation()}>
            <div style={styles.headerPopUp}>
              <h2 style={styles.tieudePopUp}>{activePolicy.title}</h2>
              <button 
                onClick={() => setActivePolicy(null)} 
                style={{
                  ...styles.nutTatPopUp,
                  backgroundColor: hoveredLink === 'close-btn' ? 'rgba(59, 31, 26, 0.1)' : 'transparent',
                  transform: hoveredLink === 'close-btn' ? 'rotate(90deg)' : 'rotate(0deg)'
                }}
                onMouseEnter={() => setHoveredLink('close-btn')}
                onMouseLeave={() => setHoveredLink(null)}
              >
                ✕
              </button>
            </div>
            {/* Class name cho thanh cuộn được đưa ra JSX chuẩn */}
            <div style={styles.noiDungPopUp} className="policy-modal-scroll">
              {activePolicy.content}
            </div>
          </div>
        </div>
      )}

      {/* STYLE & ANIMATION TOÀN CỤC KÈM MEDIA QUERIES */}
      <style>{`
        @keyframes popupOpenAnim {
          from { opacity: 0; transform: scale(0.96) translateY(15px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes floatLotus {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-10px) rotate(0.5deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
        .lotus-float {
          animation: floatLotus 8s ease-in-out infinite;
        }
        .policy-modal-scroll::-webkit-scrollbar { width: 5px; }
        .policy-modal-scroll::-webkit-scrollbar-track { background: transparent; }
        .policy-modal-scroll::-webkit-scrollbar-thumb { background: rgba(59, 31, 26, 0.15); border-radius: 10px; }

        /* ========================================
           RESPONSIVE
           Laptop lớn (> 1150px) giữ nguyên gốc
        ======================================== */
        
        /* Màn hình Laptop nhỏ (ví dụ 1024px) - Xử lý lỗi đè chữ */
        @media (max-width: 1150px) {
          .footer-lotus {
            right: -35% !important; /* Đẩy lùi sang phải */
            height: 150% !important; /* Thu nhỏ bớt */
            bottom: -50% !important;
            opacity: 0.25 !important; /* Làm mờ để không cản trở việc đọc chữ */
          }
        }

        /* Màn hình Máy tính bảng (< 992px) */
        @media (max-width: 992px) {
          .footer-col-left { flex: 0 0 200px !important; }
          .footer-col-center { flex: 0 0 250px !important; }
          .footer-col-right { flex: 0 0 200px !important; }
          .footer-lotus {
            right: -40% !important;
            opacity: 0.2 !important;
          }
        }

        /* Màn hình Điện thoại (< 768px) */
        @media (max-width: 768px) {
          .footer-container {
            padding: 60px 0 40px 0 !important;
          }
          .footer-main-content {
            flex-direction: column !important;
            align-items: center !important;
            padding: 0 20px !important;
          }
          .footer-col-left, .footer-col-center, .footer-col-right {
            flex: 1 1 auto !important;
            align-items: center !important;
            text-align: center !important;
            width: 100% !important;
          }
          .footer-logo {
            margin-top: -30px !important;
            margin-bottom: -10px !important;
          }
          .footer-divider {
            margin-top: 10px !important;
            margin-bottom: 10px !important;
            margin-left: auto !important;
            margin-right: auto !important;
            width: 150px !important;
          }
          .footer-copyright {
            margin-top: 10px !important;
            margin-bottom: 10px !important;
            margin-left: auto !important;
            margin-right: auto !important;
          }
          .footer-menu-link {
            text-align: center !important;
          }
          /* Ẩn hoàn toàn hoa sen trên điện thoại để không phá khung layout */
          .footer-lotus {
            display: none !important;
          }
          /* Đẩy cụm nút nổi lên để tránh đè nút chatbot */
          .footer-floating-actions {
            right: 20px !important;
            bottom: 120px !important;
          }
        }

        /* Tối ưu hóa khung Pop-up Chính sách trên điện thoại */
        @media (max-width: 640px) {
          .footer-modal-khung {
            max-width: 95% !important;
            margin: 10px !important;
            border-radius: 12px !important;
          }
        }
      `}</style>
    </footer>
  );
};

// --- HỆ THỐNG STYLE NỘI BỘ (GIỮ NGUYÊN GỐC DÀNH CHO LAPTOP LỚN) ---
const styles = {
  footerContainer: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#FAF0F2', 
    color: '#3B1F1A',           
    padding: '80px 0 60px 0',
    fontFamily: "'Inter', sans-serif",
    overflow: 'hidden', 
    boxSizing: 'border-box',
  },
  mainContent: {
    position: 'relative',
    zIndex: 2, 
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start', /* Giữ nguyên flex-start cho laptop */
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 40px 0 20px',
    gap: '20px',
  },
  
  colLeft: {
    flex: '0 0 280px', /* Giữ nguyên kích thước cho laptop */
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  logoImage: {
    width: '300px',
    height: 'auto',
    marginTop: '-80px',
    objectFit: 'contain',
    marginBottom: '-40px', 
  },
  copyrightDivider: {
    width: '60%',
    height: '1px',
    marginLeft: '60px',
    backgroundColor: 'rgba(59, 31, 26, 0.15)',
    marginBottom: '10px',
  },
  copyrightText: {
    margin: 10,
    marginLeft: '60px',
    fontSize: '10px',
    fontWeight: '500',
    letterSpacing: '0.05em',
    color: '#6e5a58',
  },

  colCenter: {
    flex: '0 0 320px', /* Giữ nguyên kích thước cho laptop */
    display: 'flex',
    flexDirection: 'column',
  },
  headingStyle: {
    fontSize: '13px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    margin: '0 0 16px 0',
    color: '#3B1F1A',
  },
  plainList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 10px 0',
  },
  textItem: {
    fontSize: '13px',
    color: '#6e5a58',
    marginBottom: '12px',
    lineHeight: '1.6',
    fontWeight: '400',
  },
  socialGroup: {
    display: 'flex',
    gap: '12px',
  },
  socialIconBtn: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: '#c632ae', 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'opacity 0.2s ease',
  },

  colRight: {
    flex: '0 0 280px', /* Giữ nguyên kích thước cho laptop */
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    paddingTop: '2px', 
  },
  menuLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    fontFamily: 'inherit',
    fontSize: '12.5px',
    fontWeight: '500',
    letterSpacing: '0.05em',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.3s ease',
  },

  lotusDecor: {
    position: 'absolute',
    right: '-20%',
    bottom: '-75%',
    height: '200%',
    width: 'auto',
    objectFit: 'contain',
    zIndex: 1,
    opacity: 0.9,
    pointerEvents: 'none', 
  },

  floatingActionWrapper: {
    position: 'fixed',
    right: '60px',
    bottom: '180px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    zIndex: 99,
  },
  floatingBtn: {
    width: '46px',
    height: '46px',
    borderRadius: '50%',
    backgroundColor: '#c632ae', 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    border: 'none',
  },

  overlayModal: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(30, 20, 18, 0.4)", 
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999, 
    padding: "20px",
  },
  khungPopUp: {
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "#ffffff",
    borderRadius: "16px", 
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    animation: "popupOpenAnim 0.35s cubic-bezier(0.2, 0.8, 0.2, 1)" 
  },
  headerPopUp: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",
    backgroundColor: "#FAF0F2",
    borderBottom: "1px solid rgba(59, 31, 26, 0.06)"
  },
  tieudePopUp: {
    margin: 0,
    fontSize: "17px",
    fontWeight: "700",
    color: "#3B1F1A"
  },
  nutTatPopUp: {
    background: "none", border: "none", fontSize: "16px", color: "#3B1F1A",
    cursor: "pointer", width: "32px", height: "32px", borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    transition: "all 0.25s ease-in-out"
  },
  noiDungPopUp: {
    padding: "24px",
    maxHeight: "70vh",
    overflowY: "auto",
  },
  modalBodyContent: {
    fontFamily: "'Inter', sans-serif", color: '#4A3532', fontSize: '14px',
    lineHeight: '1.7', textAlign: 'justify'
  },
  subSectionTitle: {
    fontSize: '15px', fontWeight: '700', color: '#3B1F1A',
    margin: '20px 0 12px 0', paddingLeft: '10px',
    borderLeft: '2px solid #8f86a8'
  },
  modalList: {
    margin: '0 0 16px 0', paddingLeft: '20px', listStyleType: 'disc',
    display: 'flex', flexDirection: 'column', gap: '10px'
  }
};

export default Footer;